import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeartbeat } from "@fortawesome/free-solid-svg-icons";
import Loginform from "../components/Auth/login-form";
import Resetform from "../components/Auth/reset-form";
import { useSearchParams } from "react-router-dom";

const Auth = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [type, setType] = useState<string>(searchParams.get("step") || "auth");
  const [scaleAnimation, setScaleAnimation] = useState<string>("");

  // Keep auth page light even if the app is in dark mode
  useEffect(() => {
    const wasDark = document.documentElement.classList.contains("dark");
    document.documentElement.classList.remove("dark");
    return () => {
      if (wasDark) document.documentElement.classList.add("dark");
    };
  }, []);

  const HandleFlip = () => {
    setScaleAnimation(
      scaleAnimation === "animate-login-scale"
        ? "animate-forgot-scale"
        : "animate-login-scale",
    );
    setType((prev) => (prev === "auth" ? "reset" : "auth"));
    setSearchParams({ step: type === "auth" ? "reset" : "auth" });
  };

  return (
    <div className="relative flex min-h-screen w-full flex-col overflow-hidden bg-[#EEF3FA] lg:flex-row">
      {/* Soft light atmosphere */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-24 top-0 h-[420px] w-[420px] rounded-full bg-[#BFD6FF]/55 blur-3xl" />
        <div className="absolute bottom-0 right-0 h-[480px] w-[480px] rounded-full bg-[#D7E8FF]/70 blur-3xl" />
        <div className="absolute left-1/3 top-1/2 h-64 w-64 -translate-y-1/2 rounded-full bg-white/70 blur-3xl" />
      </div>

      {/* Brand panel */}
      <div className="relative z-10 flex w-full flex-col items-center justify-center px-5 py-8 sm:px-8 lg:w-[48%] lg:px-16 lg:py-12">
        <div className="animate-fade-in text-center">
          <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-[#1562EE] shadow-[0_12px_30px_rgba(21,98,238,0.28)]">
            <FontAwesomeIcon
              icon={faHeartbeat}
              className="text-[28px] text-white"
            />
          </div>
          <p className="mb-2 font-[Gilroy-Medium] text-[15px] tracking-[0.08em] text-[#6B7C99] uppercase">
            Welcome to
          </p>
          <h1 className="font-[Gilroy-Bold] text-[32px] leading-none text-[#152C55] sm:text-[44px] md:text-[56px]">
            HealthSure
          </h1>
          <p className="mx-auto mt-4 max-w-sm font-[Gilroy-Medium] text-[15px] leading-relaxed text-[#6B7C99]">
            Monitor health and system logs across all your Sure projects in one
            place.
          </p>
        </div>
      </div>

      {/* Form panel */}
      <div className="relative z-10 flex w-full items-center justify-center px-4 pb-10 sm:px-5 lg:w-[52%] lg:px-10 lg:pb-0">
        <div className="animate-fade-in-slow relative min-h-[460px] w-full max-w-[430px] sm:h-[500px] [perspective:1200px]">
          <div
            className={`relative h-full w-full transition-all duration-500 [transform-style:preserve-3d] [transform:rotateY(${
              type === "auth" ? 0 : 180
            }deg)] ${scaleAnimation}`}
          >
            <Loginform HandleFlip={HandleFlip} />
            <Resetform HandleFlip={HandleFlip} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Auth;
